import React from 'react'
import { Form, Grid } from 'semantic-ui-react'
import RichTextEditor from '../../RichTextEditor'
import FileUploadButton from '../../fileUploadButton'

const details = ({obj, language, onChange}) => {
  const fileAudioGuide = obj.translations[language.code].file_audio_guide ? obj.translations[language.code].file_audio_guide : null

  return (
    <div>
      <Form.Field>
        <Form.Input label='Titre' placeholder="Titre" id="title" value={obj.translations[language.code].title} onChange={(e) => onChange(e, language.code)} />
      </Form.Field>
      <Form.Group widths='equal'>
        <Form.Input label="Siècle" placeholder="Siècle" id="century_1" value={obj.translations[language.code].century_1} onChange={(e) => onChange(e, language.code)} />
        <Form.Input label="Autre siècle (optionnel)" placeholder="Autre siècle (optionnel)" id="century_2" value={obj.translations[language.code].century_2} onChange={(e) => onChange(e, language.code)} />
      </Form.Group>
      <Form.Field>
        <Form.Input label="Titre du médaillon (optionnel)" placeholder="Titre de l'instruction (optionnel)" id="medallion_title" value={obj.translations[language.code].medallion_title} onChange={(e) => onChange(e, language.code)} />
      </Form.Field>
      <Form.Field>
        <Form.Input label="Titre de l'instruction" placeholder="Titre de l'instruction" id="instruction_title" value={obj.translations[language.code].instruction_title} onChange={(e) => onChange(e, language.code)} />
      </Form.Field>
      <Form.Field>
        <label>Instructions</label>
        <RichTextEditor id='instruction' value={obj.translations[language.code].instruction} onChange={(e) => onChange(e, language.code)} />
      </Form.Field>
      <Form.Field>
        <label>Contenu</label>
        <RichTextEditor id='content' value={obj.translations[language.code].content} onChange={(e) => onChange(e, language.code)} />
      </Form.Field>
      <Form.Field>
        <Form.Input label='Texte de "Vous pouvez aussi"' placeholder="" id="push_label" value={obj.translations[language.code].push_label} onChange={(e) => onChange(e, language.code)} />
      </Form.Field>
      <Form.Field>
        <label>Fichier audio (.mp3)</label>
        <Grid columns={3}>
          <Grid.Row>
            <Grid.Column>
              <FileUploadButton id='file_audio_guide' label='Fichier MP3' image={fileAudioGuide} onChange={(e) => onChange(e, language.code)} />
            </Grid.Column>
            <Grid.Column>
            </Grid.Column>
            <Grid.Column>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form.Field>
    </div>
  )
}

export default details



// WEBPACK FOOTER //
// ./src/components/form/guide/details.js